module.exports = __webpack_public_path__ + "static/img/质量保证.08b60f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/image/质量保证.jpg
// module id = PONN
// module chunks = 1